module.exports = __webpack_public_path__ + "img/Ströumgsrettungsgruppe.4c53afc1.svg";